import React from 'react';
import { GlowEffect } from './GlowEffect';

interface RibbonProps {
  children: React.ReactNode;
}

export const Ribbon: React.FC<RibbonProps> = ({ children }) => {
  return (
    // Positionnement global
    <div className="flex self-end">
      {/* Container qui définit la taille du badge */}
      <div className="relative inline-block">
        {/* L’effet de glow prend toute la place en arrière-plan */}
        <GlowEffect
          blur="soft"
          className="rounded-full"
          // ajustez éventuellement scale/duration/colors selon votre goût
        />
        {/* Le contenu textuel, au-dessus du glow */}
        <div className="relative z-10 px-4 pt-2 pb-1.5 bg-neutral-black text-white rounded-full uppercase text-xs font-normal">
          {children}
        </div>
      </div>
    </div>
  );
};
